import React, { useEffect, useState, useContext } from "react";
import VerticalNavigation from "../components/VerticalNavigation";
import AuthContext from "../context/AuthContext";
import DataSplit from "../components/DataSplit";
import Spinner from "../components/loader";
import Swal from "sweetalert2";

const ModelSelection = () => {
  const { authTokens } = useContext(AuthContext);
  const [procdata, setProcsData] = useState(null);
  const [loading, setLoading] = useState(false);


  let dataSplitting = async () => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/data_splitting/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
    });
    const data = await response.json();
    if (response.status === 200) {
      // console.log('data split:',data.Features);
      setProcsData(data["Features"]);
      setLoading(false);

    }else {
      alert("Please Consider!.. All Required steps you have performed.");
      setLoading(false);
    }
  };

  useEffect(() => {
    dataSplitting();
  }, []);

  //linear regression
  // const [savemodel, setSaveModel] = useState(false);
  const [linearresponse, setLinearResponse] = useState();


  let linearRegression = async(save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/linearregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      setLoading(false);
      // alert(data["Msg"]);
      Swal.fire({
        icon:'success',
        text:"Linear Regression Model Trained Successfully.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLinearResponse(data);
    } else {
      // alert("Please Consider!.. All Required steps you have performed.");
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  //lasso regression
  const [lassoresponse, setLassoResponse] = useState(null);


  let lassoRegression = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/lassoregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      setLoading(false);
      // alert(data["Msg"]);
      Swal.fire({
        icon:'success',
        text:data['Msg'],
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLassoResponse(data);
    } else {
      // alert("Please Consider!.. All Required steps you have performed.");
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  //ridge regression
  const [ridgeresponse, setRidgeResponse] = useState();

  
  let ridgeregression = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/ridgeregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      // alert(data["Msg"]);

      Swal.fire({
        icon:'success',
        text:data['Msg'],
        title:"Training",
        confirmButtonText:"Ok"

      })
      setRidgeResponse(data);
      setLoading(false);
    } else {
      // alert("Please Consider!.. All Required steps you have performed.");
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  //dicision tree
  const [dtresponse, setDtResponse] = useState();

  
  let dicisionTreeRegression = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/dtregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      // alert(data["Msg"]);
      Swal.fire({
        icon:'success',
        text:data['Msg'],
        title:"Training",
        confirmButtonText:"Ok"

      })
      setDtResponse(data);
      setLoading(false);
    } else {
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      // alert("Please Consider!.. All Required steps you have performed.");
      setLoading(false);
    }
  };

  // random forest Regression
  const [randomresponse, setRandomResponse] = useState();
  
  let randomForestRegression = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/randomregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      // alert(data["Msg"]);
      Swal.fire({
        icon:'success',
        text:data['Msg'],
        title:"Training",
        confirmButtonText:"Ok"

      })
      setRandomResponse(data);
      setLoading(false);
    } else {
      // alert("Please Consider!.. All Required steps you have performed.");
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  // svm
  const [svmresponse, setSvmResponse] = useState();

 
  let supportVMRegression = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/svrregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save}),
    });
    const data = await response.json();
    if (response.status === 200) {
      // alert(data["Msg"]);
      Swal.fire({
        icon:'success',
        text:data['Msg'],
        title:"Training",
        confirmButtonText:"Ok"

      })
      setSvmResponse(data);
      setLoading(false);
    } else {
      // alert("Please Consider!.. All Required steps you have performed.");
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  // KNN
  const [knnresponse, setKnnResponse] = useState();

  
  let kNearestNeighborRegression = async (save) => {
    setLoading(true);
    let response = await fetch(`${process.env.REACT_APP_URL}/knnregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      // alert(data["Msg"]);
      Swal.fire({
        icon:'success',
        text:data['Msg'],
        title:"Training",
        confirmButtonText:"Ok"

      })
      setKnnResponse(data);
      setLoading(false);
    } else {
      // alert("Please Consider!.. All Required steps you have performed.");
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  //xgboost
  const [xgbresponse, setXgbResponse] = useState();

  
  let xgboostRegression = async (save) => {
    setLoading(true);

    let response = await fetch(`${process.env.REACT_APP_URL}/xgbregression/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + String(authTokens.access),
      },
      body: JSON.stringify({ save }),
    });
    const data = await response.json();
    if (response.status === 200) {
      // alert(data["Msg"]);
      Swal.fire({
        icon:'success',
        text:data['Msg'],
        title:"Training",
        confirmButtonText:"Ok"

      })
      setXgbResponse(data);
      setLoading(false);
    } else {
      // alert("Please Consider!.. All Required steps you have performed.");
      Swal.fire({
        icon:'error',
        text:"Please Consider!.. All Required steps you have performed.",
        title:"Training",
        confirmButtonText:"Ok"

      })
      setLoading(false);
    }
  };

  return (
    <>
      <div className="wrapper">
        <VerticalNavigation />
        {loading ? <Spinner /> : null}
        <div className="container bg-light rounded main_content mx-2">
          <div className="modal-body">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#datasplit"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Data spliting</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#lr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Linear Regression</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#lassor"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Lasso Regression</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#rr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">Ridge Regression</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link "
                  data-bs-toggle="tab"
                  href="#dtr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    Decision Tree Regression
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#rfr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    Random Forest Regression
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#svr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    Support Vector Regression
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#knnr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">
                    K-Neirest Neighbor Regression
                  </span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#xgbr"
                  role="tab"
                >
                  <span className="d-none d-sm-block">XGBOOST Regression</span>
                </a>
              </li>
            </ul>

            {/* <!-- Tab panes --> */}
            <div className="tab-content p-3">
              <div className="tab-pane active" id="datasplit" role="tabpanel">
                <h3 className="text-center">
                  Spliting Training and Testing data....
                </h3>
                <div className="d-flexjustify-content-between flex-wrap">
                  {procdata && <DataSplit procdata={procdata} />}
                </div>
              </div>
              <div className="tab-pane" id="lr" role="tabpanel">
                <h3 className="text-center">Linear Regression....</h3>
                <div className="d-flexjustify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>linearRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>linearRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {linearresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Linear Regression</td>
                            <td>{linearresponse["RMSE"]}</td>
                            <td>{linearresponse["MSE"]}</td>
                            <td>{linearresponse["MAE"]}</td>
                            <td>{linearresponse["R2"]}</td>
                            <td>{linearresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="lassor" role="tabpanel">
                <h3 className="text-center">Lasso Regression....</h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>lassoRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>lassoRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {lassoresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Lasso Regression</td>
                            <td>{lassoresponse["RMSE"]}</td>
                            <td>{lassoresponse["MSE"]}</td>
                            <td>{lassoresponse["MAE"]}</td>
                            <td>{lassoresponse["R2"]}</td>
                            <td>{lassoresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="rr" role="tabpanel">
                <h3 className="text-center">Ridge Regression....</h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>ridgeregression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>ridgeregression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {ridgeresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ridge Regression</td>
                            <td>{ridgeresponse["RMSE"]}</td>
                            <td>{ridgeresponse["MSE"]}</td>
                            <td>{ridgeresponse["MAE"]}</td>
                            <td>{ridgeresponse["R2"]}</td>
                            <td>{ridgeresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="dtr" role="tabpanel">
                <h3 className="text-center">Decision Tree Regression....</h3>
                <div className="justify-content-between flex-wrap">
                  <label>Number of Trees:</label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <input type="number" step="any" name="dtn" />
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>dicisionTreeRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>dicisionTreeRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {dtresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Decision Tree Regression</td>
                            <td>{dtresponse["RMSE"]}</td>
                            <td>{dtresponse["MSE"]}</td>
                            <td>{dtresponse["MAE"]}</td>
                            <td>{dtresponse["R2"]}</td>
                            <td>{dtresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="rfr" role="tabpanel">
                <h3 className="text-center">Random Forest Regression....</h3>
                <div className="justify-content-between flex-wrap">
                  <label>Number of Trees:</label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <input type="number" step="any" name="dtn" />
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>randomForestRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>randomForestRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {randomresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>RandomForest Regression</td>
                            <td>{randomresponse["RMSE"]}</td>
                            <td>{randomresponse["MSE"]}</td>
                            <td>{randomresponse["MAE"]}</td>
                            <td>{randomresponse["R2"]}</td>
                            <td>{randomresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="svr" role="tabpanel">
                <h3 className="text-center">Support Vector Regression....</h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>supportVMRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>supportVMRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {svmresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>SVM Regression</td>
                            <td>{svmresponse["RMSE"]}</td>
                            <td>{svmresponse["MSE"]}</td>
                            <td>{svmresponse["MAE"]}</td>
                            <td>{svmresponse["R2"]}</td>
                            <td>{svmresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="knnr" role="tabpanel">
                <h3 className="text-center">
                  K-Nearest Neighbor Regression....
                </h3>
                <div className="justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>kNearestNeighborRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>kNearestNeighborRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {knnresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>KNN Regression</td>
                            <td>{knnresponse["RMSE"]}</td>
                            <td>{knnresponse["MSE"]}</td>
                            <td>{knnresponse["MAE"]}</td>
                            <td>{knnresponse["R2"]}</td>
                            <td>{knnresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <div className="tab-pane" id="xgbr" role="tabpanel">
                <h3 className="text-center">XGboost Regression....</h3>
                <div className=" justify-content-between flex-wrap">
                  <div className="d-flex">
                    <button
                      className="btn btn-success my-5 mx-5"
                      onClick={()=>xgboostRegression(false)}
                    >
                      Train
                    </button>
                    <button
                      className="btn btn-warning mx-5 my-5"
                      onClick={()=>xgboostRegression(true)}
                    >
                      Train&Save
                    </button>
                  </div>
                  <div className="my-5">
                    {xgbresponse && (
                      <table>
                        <thead>
                          <tr>
                            <th>Model Name</th>
                            <th>RMSE</th>
                            <th>MSE</th>
                            <th>MAE</th>
                            <th>R2</th>
                            <th>Adj R2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>XGBoost Regression</td>
                            <td>{xgbresponse["RMSE"]}</td>
                            <td>{xgbresponse["MSE"]}</td>
                            <td>{xgbresponse["MAE"]}</td>
                            <td>{xgbresponse["R2"]}</td>
                            <td>{xgbresponse["AdjR2"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModelSelection;
